import { Dialog, DialogTitle, DialogContent, DialogActions, Button, CircularProgress } from '@mui/material'
import { SetStateAction } from 'react'
import { LoginFormClasses, TextInput } from "react-admin"
import { Form, Dispatch, required, useNotify, useSafeSetState, useTranslate } from 'ra-core'
import useLoginCustom from './useLoginCustom'

export type SecondFactor = {
  authKey?: string | null, 
  userId?: string | null, 
  secondFactor?: string
}

const SecondFactorLogin = ({secondFactor, setSecondFactor}: {secondFactor?: SecondFactor, setSecondFactor: Dispatch<SetStateAction<SecondFactor | undefined>>}) => {

  const notify = useNotify()
  const login = useLoginCustom()
  const translate = useTranslate()

  const [loading, setLoading] = useSafeSetState(false)

  const handleClose = () => {
    setSecondFactor(undefined)
  }

  const submit = async(values: any) => {
    setLoading(true);
    login({loginType: "login2Fa", secondFactor: {authKey: secondFactor?.authKey, userId: secondFactor?.userId, secondFactor: values.secondFactor}})
      .then(() => {
        setLoading(false)
      })
      .catch(error => {
        setLoading(false)
        notify(
          typeof error === 'string'
              ? error
              : typeof error === 'undefined' || !error.message
              ? 'ra.auth.sign_in_error'
              : error.message,
          {
              type: 'error',
              messageArgs: {
                  _:
                      typeof error === 'string'
                          ? error
                          : error && error.message
                          ? error.message
                          : undefined,
              },
          }
        )
      })
  }

  return (
    <Dialog open={secondFactor !== undefined} onClose={handleClose} >
      <DialogTitle>2-Faktor-Login</DialogTitle>
      <Form 
        onSubmit={submit}
        mode="onChange"
        noValidate
      >
        <DialogContent>
          <TextInput 
            autoFocus
            type='password' 
            source='secondFactor' 
            label="Code" 
            helperText="Bitte gib hier den 6-stelligen Sicherheitscode ein, der in deiner Authenticator App angezeigt wird." 
            validate={required()}
          />
        </DialogContent>
        <DialogActions>
          <Button 
            onClick={handleClose} 
            size='small'
          >
            Abbrechen
          </Button>
          <Button
              variant={"contained"}
              type="submit"
              disabled={loading}
              className={LoginFormClasses.button}
              size='small'
          >
              {loading ? (
                  <CircularProgress
                      className={LoginFormClasses.icon}
                      size={19}
                      thickness={3}
                  />
              ) : (
                  translate('ra.auth.sign_in')
              )}
          </Button>
        </DialogActions>
      </Form>
    </Dialog>
  )
}

export default SecondFactorLogin